import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export const nextMidnight = () => {
  const midnight = new Date();
  midnight.setHours(24, 0, 0, 0);
  return midnight;
};

export class CountdownTimer extends Component {
  constructor(props) {
    super(props);
    const { countdownTo } = props;
    const now = Date.now();
    const countdownTime = countdownTo - now;

    this.updateTimer = this.updateTimer.bind(this);
    this.state = {
      countdownTime: Math.max(countdownTime, 0),
    };
  }

  componentDidMount() {
    this.timer = setInterval(this.updateTimer, 1000);
    this.intervalStartTime = Date.now();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  updateTimer() {
    const distance = Date.now() - this.intervalStartTime;
    const updatedCountdownTime = this.state.countdownTime - distance;
    if (updatedCountdownTime >= 0) {
      this.setState({ countdownTime: updatedCountdownTime });
      this.intervalStartTime = Date.now();
    } else {
      this.setState({ countdownTime: 0 });
      clearInterval(this.timer);
    }
  }

  calculateTime() {
    const { countdownTime } = this.state;
    // Time calculations for hours, minutes and seconds
    return {
      hours: Math.floor((countdownTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((countdownTime % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((countdownTime % (1000 * 60)) / 1000),
    };
  }

  render() {
    const { hours, minutes, seconds } = this.calculateTime();
    return (
      <FormattedMessage
        id="count.down.timer"
        defaultMessage="{hours}h {minutes}m {seconds}s"
        values={{
          hours,
          minutes,
          seconds,
        }}
      />
    );
  }
}

CountdownTimer.propTypes = {
  countdownTo: PropTypes.number.isRequired,
};
